/* @flow weak */
import apiRequest from 'lib/apiRequest';
import Entity from 'lib/Entity';
import Groups from 'collections/Groups';
import { cloneDeep } from 'lodash';

export default class TeacherDetail extends Entity {
  getCreatedAt() {
    return this.get('created_at');
  }

  getName() {
    return this.get('name');
  }

  getFirstName() {
    return this.get('first_name');
  }

  getGroups() {
    return this.get('groups');
  }

  getLast30DaysAnnouncementsCount() {
    return this.get('last_30_days_announcements_count');
  }

  getLast30DaysParticipantChatCount() {
    return this.get('last_30_days_participant_chats_count');
  }

  parse(response: Object) {
    const teacherDetail = cloneDeep(response);
    if (teacherDetail['groups']) {
      teacherDetail['groups'] = Groups.fromJSON(teacherDetail['groups']);
      // HACK for loading nested entities instead of the GroupView entity
      teacherDetail['groups'].forEach((group) => {
        group.set('permissions', {
          can_delete: false,
          can_edit: false,
          can_post: false,
          // Allow admins to always join and leave
          can_join: true,
          can_leave: true,
        });
      });
    }
    if (teacherDetail['created_at']) {
      teacherDetail['created_at'] = new Date(teacherDetail['created_at']);
    }
    return teacherDetail;
  }

  static getTeacherByOrgAndUserId(orgId, userId) {
    return apiRequest(`/managed_orgs/${orgId}/teachers/${userId}`, 'GET')
      .then(teacherDetail => TeacherDetail.fromJSON(teacherDetail));
  }
}



// WEBPACK FOOTER //
// ./src/admin/entities/TeacherDetail.js